module.exports = __webpack_public_path__ + "img/NoSearch@3x.9902b4ec.png";